module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Readers love")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("K")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("ATE")]), _vm._v(" "), _c('span', {
    staticClass: "t2"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "t2"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("URRAY")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("The Silence of the Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“This is a must read for hopeless romantics….”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—MM Good Book Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“I found "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("The Silence of the Stars")]), _vm._v(" easy to read, it was sweet and gentle, and flowed well.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Prism Book Alliance")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“I love Kate’s writing, it’s quiet and thoughtful and she gives her characters so much depth.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—The Tipsy Bibliophile")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("The Stars that Tremble")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“"), _c('span', {
    staticClass: "t6"
  }, [_vm._v("The Stars That Tremble")]), _vm._v(" has so many lovely elements to its story that it can be appreciated on multiple levels.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Joyfully Jay")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“Kate McMurray picked up my imaginary gauntlet and smacked me with it. This book was fantastic.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Live Your Life, Buy the Book")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0